export const DsfImage = dsf.defineLazyComponent("DsfImage", () => require("./image"));

export const DsfPlatformTeasWirte = dsf.defineAsyncComponent("DsfPlatformTeasWirte", () =>
  import(/*webpackChunkName:"platform_pc_sms"*/ "./sendMessage")
);
export const DsfPlatformTeasSendFixedTime = dsf.defineAsyncComponent(
  "DsfPlatformTeasSendFixedTime",
  () => import(/*webpackChunkName:"platform_pc_sms"*/ "./sendmsg/SendFixedTime")
);
export const DsfQrcode = dsf.defineAsyncComponent("DsfQrcode", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./qrcode")
);
export const DsfReadFileStructure = dsf.defineAsyncComponent("DsfReadFileStructure", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./readfilestructure")
);
export const DsfRepeatSendSetting = dsf.defineAsyncComponent("DsfRepeatSendSetting", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./repeatSendSetting")
);
export const DsfMySchedule = dsf.defineAsyncComponent("DsfMySchedule", () =>
  import(/*webpackChunkName:"platform_pc_schedule"*/ "./myschedule/schedule")
);
export const DsfMyscheduleUser = dsf.defineAsyncComponent("DsfMyscheduleUser", () =>
  import(/*webpackChunkName:"platform_pc_schedule"*/ "./myschedule/scheduleUser")
);
export const DsfMyScheduleFigure = dsf.defineAsyncComponent("DsfMyScheduleFigure", () =>
  import(/*webpackChunkName:"platform_pc_schedule"*/ "./myschedule/scheduleFigure")
);
export const DsfMyscheduleCalendar = dsf.defineAsyncComponent("DsfMyscheduleCalendar", () =>
  import(/*webpackChunkName:"platform_pc_schedule"*/ "./myschedule/scheduleCalendar")
);


export const DsfRegisterDatabase = dsf.defineAsyncComponent("DsfRegisterDatabase", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./registerDatabase")
);
export const DsfSelectPermissions = dsf.defineAsyncComponent("DsfSelectPermissions", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./selectPermissions/selectPermissions")
);

// export DsfImage from "./image";
// export DsfRegisterDatabase from  "./registerDatabase";
// export DsfSelectPermissions from  "./selectPermissions/selectPermissions";
